class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.activeVideos = [];

    window.loadSwiper.then((swiper) => {
      this.swiperLib = swiper;
      this._initCarousel();
    });
  }

  connectedCallback() {
    this.handleVariantChange = (e) => {
      const { variant } = e.detail;

      if (!variant?.featured_media) return;

      const mediaId = parseInt(variant.featured_media?.id);

      this.querySelectorAll("[data-media-id]").forEach((media) => {
        media.style.display =
          parseInt(media.dataset.mediaId) === mediaId ? null : "none";
      });

      this.gallerySwiper?.slideToLoop(0);
    };

    if (!this._isMobile) {
      this._initDesktopScrollCount();
    }

    document.addEventListener("variant:changed", this.handleVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener("variant:changed", this.handleVariantChange);
  }

  _initCarousel() {
    const { Swiper, Pagination } = this.swiperLib;

    const initSwiper = () => {
      if (this.gallerySwiper || !this._isMobile) return; // skip if not mobile

      let swiperParams = {
        modules: [Pagination],
        slidesPerView: "auto",
        loop: false,
        speed: 400,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
      };

      this.gallerySwiper = new Swiper(
        this.querySelector(`.${this._prefix}__media-container`),
        swiperParams,
      );

      this.gallerySwiper.on("slideChange", () => {
        const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
          slide.classList.contains("swiper-slide-visible"),
        );
        this._selectVideo(visibleSlides);
      });
    };

    const destroySwiper = () => {
      if (this.gallerySwiper) {
        this.gallerySwiper.destroy(true, true);
        this.gallerySwiper = null;
      }
    };

    const handleResize = () => {
      if (this._isMobile) {
        initSwiper();
      } else {
        destroySwiper();
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // initialize on load
  }

  _initDesktopScrollCount() {
    if (this._isMobile) return;

    const mediaItems = this.querySelectorAll(`.${this._prefix}__media-wrapper`);
    const counterContainer = this.querySelector('[data-slide-count]');
    const contentWrapper = document.querySelector('.main-content-wrapper');
    const stickyHeader = document.querySelector('sticky-header');

    if (!mediaItems.length || !counterContainer || !contentWrapper || !stickyHeader) return;
    const current = document.createElement('span');
    const total = document.createElement('span');
    current.className = 'current-index';
    total.className = 'total-index';
    total.textContent = mediaItems.length;
    current.textContent = mediaItems.length ? '1' : ' ';

    counterContainer.innerHTML = '';
    counterContainer.appendChild(current);
    counterContainer.insertAdjacentHTML('beforeend', ' / ');
    counterContainer.appendChild(total);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.8) {
            const index = [...mediaItems].indexOf(entry.target) + 1;
            current.textContent = index;
          }
        });
      },
      {
        root: null,
        threshold: 0.8,
      }
    );

    mediaItems.forEach((item) => observer.observe(item));

    const updateCounterPosition = () => {
      const wrapperRect = contentWrapper.getBoundingClientRect();
      const headerHeight = stickyHeader.getHeaderHeight?.() || 0;
      const offsetTop = wrapperRect.top + window.pageYOffset + 16 - headerHeight;

      counterContainer.style.position = 'sticky';
      counterContainer.style.top = `${Math.max(offsetTop, 16)}px`;
    };

    updateCounterPosition();
    
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateCounterPosition, 100);
    });
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }
}

if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}
